import { AlertController, NavController } from 'ionic-angular';
import { CognitoLogout } from './congito';
import { HttpService } from './httpService';

export function logout(alertCtrl: AlertController, httpService: HttpService): Promise<boolean> {
  return new Promise( (resolve, reject) => {
    try{
      const alert = alertCtrl.create({
        title: 'Logout',
        message: 'Are you sure you would like to proceed?',
        cssClass: 'alert',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
          },
          {
            text: 'Yes',
            handler: () => {
              alert.dismiss().then(() => {
                httpService.clearSubscriptions();
                return CognitoLogout();
              }).then(() => {
                resolve(true)
                // go to root page / redirect to LoginPage
              }).catch((e) => {
                resolve(false)
                console.error(e);
              });
              return false;
            }
          }
        ]
      });

      alert.present();
    }catch(err){
      resolve(false);
    }



  });
}



// WEBPACK FOOTER //
// ./src/services/logout.ts